import { IAreaModel } from './area.model'
import { IEnterpriseModel, enterpriseInitialState } from './enterprise.model'
export interface IUserModel {
  id?: number
  identifier?: any
  token: string
  name: string
  lastname: string
  rut: string
  position: string
  email: string
  avatar?: string
  enterprise: IEnterpriseModel
  isAdmin: boolean
  fullName?: string
  area?: IAreaModel
  permission: {
    local: boolean
    admin: boolean
    superadmin: boolean
    supervisor: boolean
  }
  supervisors?: IUserModel[]
  lang?: string
  is_superadmin?: boolean
  is_admin?: boolean
  permissions?: any
  enterprisePosition?: {
    id: number
    name: string
  }
  supervisorTokens?: string[]
}

export const userInitialState: IUserModel = {
  id: 0,
  name: '',
  token: '',
  lastname: '',
  rut: '',
  email: '',
  position: '',
  isAdmin: false,
  enterprise: enterpriseInitialState,
  area: undefined,
  permission: {
    local: false,
    admin: false,
    superadmin: false,
    supervisor: false,
  },
  supervisors: [],
}
